import { z } from 'zod';
/**
 * Pourquoi la tarification d'une offre n'a pas abouti.
 *
 * Les deux sortent en `SEARCH_SESSION_EXPIRED` sur le fil — c'est un code gelé,
 * sur lequel `apps/web` branche déjà sa relance de recherche, et le renommer
 * demanderait de faire accepter les deux formes au front avant de déployer. Le
 * motif voyage donc à côté, dans `reason`, comme le refus d'éligibilité au 3/4x :
 * les bundles déjà déployés l'ignorent et gardent leur écran actuel.
 *
 * La distinction n'est pas cosmétique. « Votre recherche a expiré » et « le
 * tarif a changé » n'apprennent pas la même chose : dans le premier cas l'offre
 * n'existe plus de notre côté, dans le second elle existe toujours et c'est son
 * prix qui a bougé. Les afficher sous le même titre laissait le client croire à
 * une erreur du site.
 */
export const SEARCH_SESSION_EXPIRY_REASONS = [
    /** Le tarif du fournisseur s'écarte de plus d'un euro de celui figé à la recherche. */
    'PRICE_CHANGED',
    /** Plus aucune offre en cache pour cette clé : la recherche est trop ancienne. */
    'SESSION_EXPIRED',
];
/** Décode un motif venu du réseau (corps d'erreur HTTP). */
export const searchSessionExpiryReasonSchema = z.enum(SEARCH_SESSION_EXPIRY_REASONS);
